import { COUNTRY_OPTIONS } from "../constants/countryOptions";

/**
 *
 * @param {Array <string>} value Array of currently selected country codes
 * @param {string} label Country being searched
 * @returns Boolean
 */
export function isCountryIncluded(label, value, language) {
  if (label === "LAC") return value.includes(label);

  let countryInfo = COUNTRY_OPTIONS.find((country) => {
    return language === "en"
      ? country["country_text_en"] === label
      : country["country_text"] === label;
  });

  if (label === "Rep. Dom." || label === "Dom. Rep.")
    return value.includes("DOM");

  if (countryInfo) {
    return value.includes(countryInfo.code);
  } else {
    return false;
  }
}
